/**
 * Pure fetch helper extracted from `useUpdateSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */
import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import type { UpdateSpaceRequest, UpdateSpaceResponse } from '../../controllers/space-store/types';

const SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';

export type UpdateSpaceFetchParams = {
	spaceId: string;
	request: UpdateSpaceRequest;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const updateSpaceFetchAction = async ({
	spaceId,
	request,
	cloudId,
	product,
	experienceId,
}: UpdateSpaceFetchParams): Promise<UpdateSpaceResponse> =>
	performHttpFetch({
		path: `${SPACES_API_PATH}/${spaceId}`,
		options: {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
			body: JSON.stringify(request),
		},
	});
